import { useNavigate, useParams } from 'react-router-dom'
import { useQueryParams } from 'use-query-params'

import { useNLUDataStore } from '../../../../../stores/nluDataStore'
import { buildQuery, DashArrayParam } from '../../../../../utils/useQueryParams'
import { NLUFilterCategoryEnum } from '../NLUFilters/NLUFilters'

import styles from './change-tab-tab.module.scss'

function ChangeTabTab() {
    const navigate = useNavigate()

    const { tab } = useParams()

    const [query] = useQueryParams({
        [NLUFilterCategoryEnum.ENTITIES]: DashArrayParam,
        [NLUFilterCategoryEnum.INTENTS]: DashArrayParam,
    })

    const [{ tabs }] = useNLUDataStore()

    return (
        <div className={styles.changeTab}>
            <select
                value={tab}
                onChange={(e) =>
                    navigate({
                        pathname: `/training-data/data/${e.target.value}`,
                        search: buildQuery(query),
                    })
                }
                className={styles.changeTab__select}
            >
                {tabs?.map((tab) => (
                    <option key={tab} value={tab}>
                        {tab}
                    </option>
                ))}
            </select>
        </div>
    )
}

export default ChangeTabTab
